/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ uptime: NonNullable<unknown>, subject: NonNullable<unknown>, duration: NonNullable<unknown>, calls: NonNullable<unknown> }} Seo_Measured_LatencyInputs */

const en_seo_measured_latency = /** @type {(inputs: Seo_Measured_LatencyInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Over the last 30 days, ${i?.uptime} of ${i?.subject} calls through AnyAPI succeeded, with a median response time of ${i?.duration} across ${i?.calls} measured calls.`)
};

const zh_hans1_seo_measured_latency = /** @type {(inputs: Seo_Measured_LatencyInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`过去 30 天，通过 AnyAPI 发起的 ${i?.subject} API 调用中有 ${i?.uptime} 成功，响应时间中位数为 ${i?.duration}，共测量 ${i?.calls} 次调用。`)
};

const pt_br2_seo_measured_latency = /** @type {(inputs: Seo_Measured_LatencyInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Nos últimos 30 dias, ${i?.uptime} das chamadas ${i?.subject} feitas pela AnyAPI tiveram sucesso, com tempo de resposta mediano de ${i?.duration}, em ${i?.calls} chamadas medidas.`)
};

const es_seo_measured_latency = /** @type {(inputs: Seo_Measured_LatencyInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`En los últimos 30 días, el ${i?.uptime} de las llamadas ${i?.subject} a través de AnyAPI tuvo éxito, con un tiempo de respuesta mediano de ${i?.duration} en ${i?.calls} llamadas medidas.`)
};

const fr_seo_measured_latency = /** @type {(inputs: Seo_Measured_LatencyInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Ces 30 derniers jours, ${i?.uptime} des appels ${i?.subject} passés par AnyAPI ont réussi, avec un temps de réponse médian de ${i?.duration}, sur ${i?.calls} appels mesurés.`)
};

const de_seo_measured_latency = /** @type {(inputs: Seo_Measured_LatencyInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`In den letzten 30 Tagen waren ${i?.uptime} der ${i?.subject}-Aufrufe über AnyAPI erfolgreich, bei einer mittleren Antwortzeit von ${i?.duration} über ${i?.calls} gemessene Aufrufe.`)
};

const ru_seo_measured_latency = /** @type {(inputs: Seo_Measured_LatencyInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`За последние 30 дней ${i?.uptime} вызовов ${i?.subject} через AnyAPI завершились успешно, медианное время ответа ${i?.duration}, измерено вызовов: ${i?.calls}.`)
};

const it_seo_measured_latency = /** @type {(inputs: Seo_Measured_LatencyInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Negli ultimi 30 giorni, il ${i?.uptime} delle chiamate ${i?.subject} tramite AnyAPI è riuscito, con un tempo di risposta mediano di ${i?.duration} su ${i?.calls} chiamate misurate.`)
};

/**
* | output |
* | --- |
* | "Over the last 30 days, {uptime} of {subject} calls through AnyAPI succeeded, with a median response time of {duration} across {calls} measured calls." |
*
* @param {Seo_Measured_LatencyInputs} inputs
* @param {{ locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }} options
* @returns {LocalizedString}
*/
export const seo_measured_latency = /** @type {((inputs: Seo_Measured_LatencyInputs, options?: { locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Seo_Measured_LatencyInputs, { locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh-Hans") return zh_hans1_seo_measured_latency(inputs)
	if (locale === "pt-BR") return pt_br2_seo_measured_latency(inputs)
	if (locale === "es") return es_seo_measured_latency(inputs)
	if (locale === "fr") return fr_seo_measured_latency(inputs)
	if (locale === "de") return de_seo_measured_latency(inputs)
	if (locale === "ru") return ru_seo_measured_latency(inputs)
	if (locale === "it") return it_seo_measured_latency(inputs)
	return en_seo_measured_latency(inputs)
});